
import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { INTERCEPTOR_MODULE_CONFIG, InterceptorModuleConfig } from '../interceptor.module.config';
import { AuthenticationService } from '../../services/authentication.service';
import { APP_CONFIG, AppConfig, APP_CONSTANTS } from '../../../app.config';
import { CookiesService } from '@app/cookies.service';
import { USER_DATA, USER_INFO, USER_TOKEN, ARTIST_INFO, WINDOWSIGHT_APP, PROMOTION_CODE, COOKIE_USER_AVATAR, COOKIE_USER_LOGGED, COOKIE_USER_TYPE, WEB_MANTEINANCE_URL } from '@app/shared/constants';
import { PopupRef } from '@app/shared/components/popup/components/popup-ref';
import { PopupService } from '@app/shared/components/popup/services/popup.service';
import { SettingsService } from '@app/modules/landing-page/services/settings.service';
import { SuspendedAccountComponent } from '@app/settings-popup/component/suspended-account/suspended-account.component';

@Injectable()
export class HttpInterceptorHandlerService {

  constructor(private route: Router,
    private popupService: PopupService,
    private settingsService: SettingsService,

    @Inject(INTERCEPTOR_MODULE_CONFIG) private interceptorModuleConfig: InterceptorModuleConfig,
    @Inject(APP_CONFIG) private appConfig: AppConfig) {

  }

  manageSuccess(evt) {
    if (this.isResponseSuccess(evt)) {
      // this.notifierService.notifyReset();
    }
  }

  manageErrors(error: HttpErrorResponse): Observable<any> {
    console.log('handler serv', error);
    if (this.isAuthError(error) && !this.route.url.includes(this.appConfig.ROUTING.VIEW.LOGIN) && !this.route.url.includes(this.appConfig.ROUTING.VIEW.SIGNUP)) {
      if (error.error != null && error.error.message.includes('suspended')) {
        console.log('user suspended');
        const ref: PopupRef = this.popupService.open(SuspendedAccountComponent);
        ref.afterClosed.subscribe(value => {
          this.settingsService.logoutClicked.next(false);
        });
      } else {
        // this.authenticationService.logout();
        CookiesService.removeItem(USER_DATA);
        CookiesService.removeItem(USER_INFO);
        CookiesService.removeItem(USER_TOKEN);
        CookiesService.removeItem(ARTIST_INFO);
        CookiesService.removeItem(WINDOWSIGHT_APP);
        CookiesService.removeItem(PROMOTION_CODE);
        CookiesService.removeItem(APP_CONSTANTS);
        CookiesService.removeItem(COOKIE_USER_AVATAR);
        CookiesService.removeItem(COOKIE_USER_LOGGED);
        CookiesService.removeItem(COOKIE_USER_TYPE);
        CookiesService.deleteAllCookies();
        CookiesService.clear();
        CookiesService.setUserLogged(false);
        if (this.route.url !== this.appConfig.ROUTING.PATH.AUTH_ERROR_REDIRECTION) {
          CookiesService.removeItem(USER_DATA);
          CookiesService.removeItem(USER_INFO);
          CookiesService.removeItem(USER_TOKEN);
          CookiesService.removeItem(ARTIST_INFO);
          CookiesService.removeItem(WINDOWSIGHT_APP);
          CookiesService.removeItem(PROMOTION_CODE);
          CookiesService.removeItem(APP_CONSTANTS);
          CookiesService.removeItem(COOKIE_USER_AVATAR);
          CookiesService.removeItem(COOKIE_USER_LOGGED);
          CookiesService.removeItem(COOKIE_USER_TYPE);
          CookiesService.deleteAllCookies();
          CookiesService.clear();
          CookiesService.setUserLogged(false);
          this.route.navigate([this.appConfig.ROUTING.PATH.AUTH_ERROR_REDIRECTION]);
        }
      }
    } //else {
      // this.notifierService.notifyError(this.interceptorModuleConfig.MESSAGE_KEYS.LOGIN_WRONG_CREDENTIALS_KEY);
    //}
    if (this.isServerError(error)) {
      if (this.isManteinanceError(error)) {
        window.open(WEB_MANTEINANCE_URL, '_self');
      }
    }
    if (this.isBadRequestError(error)) {
      // this.notifierService.notifyError(this.interceptorModuleConfig.MESSAGE_KEYS.GLOBAL_ERROR_KEY);
    }
    if (this.isParsingBodyError(error)) {
      return of(error);
    } else {
      return observableThrowError(error);
    }
  }

  private isResponseSuccess(evt) {
    return evt instanceof HttpResponse && evt.status === this.interceptorModuleConfig.HTTP_STATUS.SUCCESS_STATUS_CODE;
  }

  private isAuthError(evt) {
    return evt instanceof HttpErrorResponse && this.interceptorModuleConfig.HTTP_STATUS.AUTH_ERROR_STATUS_CODES.indexOf(evt.status) >= 0 && evt.error.message != "Password does not match. ";
  }

  private isServerError(evt) {
    return evt instanceof HttpErrorResponse && evt.status >= this.interceptorModuleConfig.HTTP_STATUS.INTERNAL_SERVER_ERROR_STATUS_CODE;
  }

  private isManteinanceError(evt) {
    return evt instanceof HttpErrorResponse && this.interceptorModuleConfig.HTTP_STATUS.MANTEINANCE_ERROR_STATUS_CODE.indexOf(evt.status) >= 0;
  }

  private isNotStockError(evt) {
    return evt instanceof HttpErrorResponse && evt.status === this.interceptorModuleConfig.HTTP_STATUS.NO_STOCK_ERROR_CODE;
  }

  private isBadRequestError(evt) {
    return evt instanceof HttpErrorResponse && evt.status === this.interceptorModuleConfig.HTTP_STATUS.BAD_REQUEST_ERROR_CODE;
  }

  private isParsingBodyError(error: HttpErrorResponse): boolean {
    return error.status === this.interceptorModuleConfig.HTTP_STATUS.SUCCESS_STATUS_CODE;
  }
}
